export enum EUserUnavailableReason {
  NOT_FOUND = 'not_found',
  SERVER_ERROR = 'server_error',
}

export interface IUserUnavailableDetail {
  userId: string;
  unavailableReason: EUserUnavailableReason;
}
